module.exports = __webpack_public_path__ + "img/1_022.b4a74ce4.jpg";